<template>
  <v-app id="inspire">
    <v-app-bar app dark color="primary">
      <v-img
        v-if="company.logo"
        alt="Logo"
        class="shrink mr-2"
        contain
        :src="`data:image/png;base64,${company.logo}`"
        transition="scale-transition"
        width="50"
        @click="$router.push({ name: 'Landing' })"
      />

      <v-btn v-else text @click="$router.push({ name: 'Landing' })">
        {{ $store.getters["Landing/company"].displayName }}
      </v-btn>

      <v-spacer />

      <v-btn
        v-if="auth.check()"
        text
        class="ml-2"
        color="white"
        light
        @click="$store.dispatch('Auth/logout')"
      >
        <span class="mr-2">Logout</span>
        <v-icon>mdi-logout</v-icon>
      </v-btn>
    </v-app-bar>

    <v-main>
      <v-container class="d-flext flex-column mt-10">
        <div class="align-self-center mt-2">
          <v-alert prominent elevation="4" type="info"
            >Cancel Activation Page</v-alert
          >
        </div>
      </v-container>
    </v-main>

    <spinner />

    <FooterComponent opacity="0.65" />
  </v-app>
</template>

<script>
import FooterComponent from "../../../components/FooterComponent";
import Spinner from "../../../plugins/loader/views/Spinner";
import { AuthService } from "../../auth/index";

export default {
  name: "ActivationCancel",
  components: { Spinner, FooterComponent },
  beforeRouteEnter(to, from, next) {
    next((v) => {
      if (AuthService.check()) {
        v.$router.push({ name: "Summary" });
      }
      if (to.params.code !== undefined) {
        v.$store.dispatch("Activation/cancelActivation", to.params.code);
      }
    });
  },

  computed: {
    auth() {
      return AuthService;
    },

    company() {
      return this.$store.getters["Landing/company"];
    },
  },

  watch: {
    "$route.name": {
      handler: function () {
        this.$store.commit("Auth/SET_ALERT", null);
      },
    },
  },
};
</script>

<style scoped></style>
